import { Component } from '@angular/core';
import { AlertController ,NavParams,ToastController,NavController} from 'ionic-angular';
import { AppState } from '../../../app/app.global';

import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { GENERATE_CODE_MOBILE,SAVE_CODE_MOBILE} from '../../../providers/config/serviceurl';
import { Utils} from '../../../providers/service/utils';
import { ToastAlert } from '../../../providers/util/toastalert';

@Component({
  selector: 'bind-phone-page',
  templateUrl: 'submitphone.html'
})
export class SubmitPhonePage {
	user:any={};
	phoneNumber:string="";
	oldMobile:any="";
	timeCode:string="获取验证码";
	timeNumber:number = 60;
	verifyCode:string="";
	timeFlag:Boolean=true;
	private timer:any;
	collback;
	constructor(public alerCtrl: AlertController,public global: AppState,public navCtrl: NavController,
				private httpService:HttpService,public navParm :NavParams,
				public toastCtrl: ToastController,public toastAlert: ToastAlert) {
		this.user = StorageService.getObj('currentUser');
		this.oldMobile = navParm.data.bindPhone;
		this.collback=this.navParm.get("collback");
	}
	getVerificationCode(){
		if(this.phoneNumber == undefined || this.phoneNumber == null || this.phoneNumber =="")
		{
			let toast = this.toastCtrl.create({
				message: '手机号不能为空',
				duration: 1000,
				position: 'middle'
			  });
			toast.present();
			return;
		}
		if(!Utils.isPoneAvailable(this.phoneNumber)){
			let toast = this.toastCtrl.create({
				message: '请输入正确的手机号',
				duration: 1000,
				position: 'middle'
			  });
			toast.present();
			return;
		}
      if(this.timeFlag){
      	this.timeFlag = false;
				let params = {'username':this.user.username,'newMobile':this.phoneNumber};
				this.httpService.post2(GENERATE_CODE_MOBILE,params).then(anyObj =>this.hanldeThing(anyObj));
      }
	}
	
	hanldeThing(obj:any){
		if(obj && obj.status=='success'){
			this.toastAlert.alertMsg(obj.message, 'middle', 1000);
			this.timer = setInterval(()=>{
				if(this.timeNumber > 0){
					this.timeNumber--;
					 this.timeCode = this.timeNumber+"s";
				}else{
					clearInterval(this.timer);
					this.timeNumber = 60;
					this.timeCode="重新获取";
					this.timeFlag=true;
				}
			},1000);
		}else{
			this.toastAlert.alertMsg(obj.message, 'middle', 1000);
		}
	}
  
bindPhoneNumber() {
	if(this.verifyCode == "")
		{
			let alert = this.alerCtrl.create({
				// title: '绑定成功',
				message: '验证码不能为空',
				buttons: ['确定']
     		});
     		alert.present();
		}else {
			let params = {'username':this.user.username,'oldMobile':this.oldMobile,'newMobile':this.phoneNumber,'checkCode':this.verifyCode};
    		this.httpService.post2(SAVE_CODE_MOBILE,params).then(anyObj =>this.handlebindPhoneNumber(anyObj));
		}

  }
  handlebindPhoneNumber(obj:any){
	if(obj && obj.status=='success'){
			let alert = this.alerCtrl.create({
			message: '绑定手机号成功！',
			buttons: [{
				text:'确定',
			handler:()=>{
				let param = 'pop';
				this.collback(param).then(()=>{
					this.navCtrl.pop();
				})
			}}]
		  });
		alert.present();
	}else{
		this.toastAlert.alertMsg("绑定手机号失败", 'middle', 1000);
	}
}
}



// WEBPACK FOOTER //
// ./src/pages/about/bind/submitphone.ts